import { z } from "zod";
// eslint-disable-next-line import/no-unresolved
import ymlConfig from "config.yml";

const schema = z.object({
  env: z.enum(["production", "preview", "development", "local"]),
  supabase: z.object({
    url: z.string(),
    apiKey: z.string(),
  }),
  paddle: z.object({
    env: z.enum(["production", "sandbox"]),
    token: z.string(),
    plans: z.object({
      lt_pass: z.string(),
      y1_pass: z.string(),
    }),
    discounts: z.object({
      y1_discount: z.string(),
      lt_discount: z.string(),
    }),
  }),
  workers: z.object({
    prompt_runner: z.object({
      url: z.string(),
    }),
  }),
});

const config = schema.parse(ymlConfig);

type Config = z.infer<typeof schema>;

export { config, type Config };
